import { render, staticRenderFns } from "./onlinefeed.vue?vue&type=template&id=ee66fe58&scoped=true"
import script from "./onlinefeed.vue?vue&type=script&lang=js"
export * from "./onlinefeed.vue?vue&type=script&lang=js"
import style0 from "./onlinefeed.vue?vue&type=style&index=0&id=ee66fe58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee66fe58",
  null
  
)

export default component.exports